<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <jm-toolbar
          customize-field-name="school"
          show-defined-list>
        </jm-toolbar>
        <div class="table-agile-info">
          <el-row class="searchForm" :gutter="10">
            <el-col :span="6" v-if="constDict.country">
              国家：
              <el-select v-model="searchData.country_id" @change="changeCountry" >
                <el-option
                  v-for="item in constDict.country.filter(item=>(item.sh_mg_id!==238 && item.sh_mg_id!==240))"
                  :key="'ct_id' + item.sh_mg_id"
                  :label="item.title"
                  :value="item.sh_country"/>
              </el-select>
            </el-col>
            <el-col :span="6">
              院校名称：
              <!--filterable-->
              <el-select v-model="searchData.sh_id" filterable multiple placeholder="请选择" value-key="sh_id" @change="changeSchool">
                <el-option
                  v-for="item in shOption"
                  :key="item.sh_id"
                  :label="item.sh_name_cn"
                  :value="item.sh_id"/>
              </el-select>
            </el-col>
            <el-col :span="6">
              学院名称：
              <el-select v-model="searchData.dp_id" @change="changeDept" filterable clearable>
                <el-option
                  v-for="item in dpOption"
                  :key="'dp_id'+item.dp_id "
                  :label="item.dp_name_cn"
                  :value="item.dp_id"/>
              </el-select>
            </el-col>
            <el-col :span="6">
              系别名称：
              <el-select v-model="searchData.xb_id" filterable clearable>
                <el-option
                  v-for="item in xbOption"
                  :key="'xb_id'+item.xb_id "
                  :label="item.xb_name_cn"
                  :value="item.xb_id"/>
              </el-select>
            </el-col>
            <el-col :span="6" v-if="constDict.attention">
              课程类型：
              <el-select v-model="searchData.attention" clearable>
                <el-option
                  v-for="item in constDict.attention.filter(item => item.pid === searchData.country_id)"
                  :key="'at_id'+ item.id"
                  :label="item.value"
                  :value="item.id"/>
              </el-select>
            </el-col>
            <el-col :span="6">
              专业名称：
              <el-input class="jm-input220" v-model="searchData.pf_name"/>
            </el-col>
          </el-row>
          <el-row class="searchBottom" :gutter="10">
            <el-col :span="24">
              <el-button type="primary" class="jm-input-common3" @click="init">搜索</el-button>
            </el-col>
          </el-row>
          <jm-tableList
            v-if="searchData"
            url="/index/u_u_college_professional/getList"
            :refresh="refresh"
            :search-data="searchData">
            <el-table-column
              slot="pf_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="pf_name">
              <template slot-scope="scope">
                <a :href="scope.row.pf_url" target="_blank">{{ scope.row.pf_name_cn }}<br/>{{ scope.row.pf_name_en }}</a>
              </template>
            </el-table-column>
            <el-table-column
              slot="sh_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="sh_name">
              <template slot-scope="scope">
                {{ scope.row.sh_name_cn }}<br/>{{ scope.row.sh_name_en }}
              </template>
            </el-table-column>
            <el-table-column
              slot="dp_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="dp_name">
              <template slot-scope="scope">
                <a v-if="scope.row.dp_url" :href="scope.row.dp_url" target="_blank">{{ scope.row.dp_name_cn }}</a>
                <span v-else>{{ scope.row.dp_name_cn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              slot="xb_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="xb_name">
              <template slot-scope="scope">
                <a v-if="scope.row.xb_url" :href="scope.row.xb_url" target="_blank">{{ scope.row.xb_name_cn }}</a>
                <span v-else>{{ scope.row.xb_name_cn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              slot="pf_ielts"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="pf_ielts">
              <div slot-scope="scope" v-html="packIeltsScore(scope.row)" />
            </el-table-column>
            <el-table-column
              slot="pf_toefl"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="pf_toefl">
              <div slot-scope="scope" v-html="packToeflScore(scope.row)" />
            </el-table-column>
            <el-table-column
              slot="pf_gmat"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="pf_gmat">
              <div slot-scope="scope" v-html="packGmatGreScore(scope.row)" />
            </el-table-column>
            <el-table-column
              slot="pf_url"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="pf_url">
              <template slot-scope="scope">
                <a :href="scope.row.pf_url" target="_blank">{{ scope.row.pf_url }}</a>
              </template>
            </el-table-column>
            <template>
              <el-table-column
                fixed="right"
                slot="lastColumn"
                label="操作"
                min-width="150">
                <template slot-scope="scope">
                  <a :href="scope.row.pf_admin_url" target="_blank" v-if="$hasPermission([62, 173])">
                    <el-button type="primary">编辑</el-button>
                  </a>
                  <a :href="scope.row.pf_url" target="_blank">
                    <el-button type="success">查看详情</el-button>
                  </a>
                </template>
              </el-table-column>
            </template>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      constDict: {},
      shOption: [],
      dpOption: [],
      xbOption: [],
      refresh: false,
      searchData: {
        country_id: 1,
        sh_id: [],
        dp_id: '',
        xb_id: '',
        sh_name: '',
        attention: '',
        pf_name: ''
      },
      timeout: null,
    };
  },
  components: { jmTableList, 'jm-toolbar': toolbar },
  created() {
    this.$http
      ._get({
        url: '/index/u_u_college_professional/searchDict'
      })
      .then(({ data }) => {
        this.constDict = data;
        this.searchData.country_id = typeof this.constDict.country === 'object' ? this.constDict.country[0].sh_country : 1;
        this.searchData.attention = '';
        this.$store.commit('updateRefresh', true);
        this.getSchoolOption();
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    },
    // 国家改变
    changeCountry() {
      this.constDict.country.forEach((i) => {
        if (this.searchData.country_id === i.sh_country) {
          this.cms_country = i.cms_country;
          this.searchData.attention = '';
        }
      });
      this.getSchoolOption();
    },
    // 学校改变
    changeSchool() {
      this.getDeptOption();
    },
    // 学院改变
    changeDept() {
      this.getXibieOption();
    },
    getSchoolOption() {
      this.searchData.sh_id = [];
      this.searchData.dp_id = '';
      this.searchData.xb_id = '';
      this.$http
        ._get({
          url: `/index/u_u_college_professional/getSchoolOption/countryId/${this.searchData.country_id}`
        })
        .then(({ data }) => {
          this.shOption = data.list;
        });
    },
    getDeptOption() {
      this.searchData.dp_id = '';
      this.searchData.xb_id = '';
      if (this.searchData.sh_id.length < 1) {
        this.dpOption = [];
        this.xbOption = [];
      } else {
        this.$http
          ._post({
            url: '/index/u_u_college_professional/getDepartmentOption',
            data: this.searchData.sh_id
          })
          .then(({ data }) => {
            this.dpOption = data.list;
          });
      }
    },
    getXibieOption() {
      this.searchData.xb_id = '';
      if (this.searchData.dp_id === '') {
        this.xbOption = Object.assign({}, {});
      } else {
        this.$http
          ._get({
            url: `/index/u_u_college_professional/getXibieOption/deptId/${this.searchData.dp_id}`
          })
          .then(({ data }) => {
            this.xbOption = data.list;
          });
      }
    },
    packIeltsScore(row) {
      let score = row.pf_ielts_score;
      const tmp = [];
      if (row.pf_ielts_point) {
        tmp.push(`各小分不低于${row.pf_ielts_point}`);
      }
      if (row.pf_ielts_memo) {
        tmp.push(row.pf_ielts_memo);
      }
      if (tmp.length) {
        score += `<span>[${tmp.join(',')}]</span>`;
      }
      return score;
    },
    packToeflScore(row) {
      let score = row.pf_toefl_score;
      if (row.pf_toefl_memo) {
        score += `<span>[${row.pf_toefl_memo}]</span>`;
      }
      return score;
    },
    packGmatGreScore(row) {
      let score = row.pf_gmat_gre;
      if (row.pf_gmat_gre_memo) {
        score += `<span>[${row.pf_gmat_gre_memo}]</span>`;
      }
      return score;
    }
  },
  watch: {
  }
};

</script>

<style scoped>
  .searchForm * {
    padding: 5px;
  }
</style>
